module.exports = __webpack_public_path__ + "static/top-898b4b6e7da47f136cc39c35de16bf0f.png";